import Vue from 'vue';
import { parseUrl } from './uri';

// 是否在服务端运行
export const isServerRender = process.env.VUE_ENV === 'server';

// 服务端的windows
// eslint-disable-next-line import/no-mutable-exports
export let vueSsrContext;
// eslint-disable-next-line import/no-mutable-exports
export let tswPlug;
// eslint-disable-next-line import/no-mutable-exports
export let platDocument;
// eslint-disable-next-line import/no-mutable-exports
export let platWindow;
// eslint-disable-next-line import/no-mutable-exports
export let serverWindowProtocol;

export const isNative = !!Vue.Native && Vue.Native.Platform !== 'browser';

export const isBrowser = () => Vue.Native.Platform === 'browser';

export const getOS = (ua) => {
  if (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) return 'and';
  if (ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) return 'ios';
  return 'unknown';
};

if (isServerRender) {
  vueSsrContext = __VUE_SSR_CONTEXT__;  // eslint-disable-line
  tswPlug = vueSsrContext.tswPlug; // eslint-disable-line
  global.fetch = vueSsrContext.fetch;
  const { request } = vueSsrContext;

  // document定义
  platDocument = {
    cookie: request.headers.cookie || '',
  };

  platWindow = {
    location: parseUrl((`${request.protocol}://${request.hostname}${request.url}`) || ''),
    navigator: {
      userAgent: request.headers['user-agent'] || '',
    },
    screen: {
      width: 0,
      height: 0,
      availWidth: 0,
      availHeight: 0,
    },
  };

  serverWindowProtocol = `${request.protocol}:`;
} else if (typeof window === 'object') { // todo
  platWindow = window;
  platDocument = document;
  serverWindowProtocol = window.location.protocol;
}

// 是否为异步版
export const isAsyncRender = !(platWindow && platWindow.__INITIAL_STATE__);

// 是否为直出版
export const isDirect = isServerRender || (platWindow && platWindow.__INITIAL_STATE__);
